export default {
  filters: {
    truncate (value) {
      let val = value.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
      if(val.length <= 100) return val
      else return val.substring(0, 100) + '...'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/truncate.js